import type { ReactDOM, ReactNode } from 'react'

import AnimateIntoView, {
  AnimationType,
} from '../AnimateIntoView/AnimateIntoView'
import Text, { TextSizes } from '../Text/Text'

export interface AnimatedSectionTitleProps {
  children: ReactNode
  className?: string
  size?: TextSizes
  testID?: string
  tag?: keyof ReactDOM
}

export default function AnimatedSectionTitle({
  children,
  className,
  size = TextSizes.primaryTitleLrg,
  testID,
  tag,
}: AnimatedSectionTitleProps) {
  return (
    <div data-testid={testID} className={className}>
      <AnimateIntoView type={AnimationType.fadeIn}>
        <Text Tag={tag ? tag : `h2`} size={size}>
          {children}
        </Text>
      </AnimateIntoView>
    </div>
  )
}
